<ng-container *ngIf="ecoFeature$ | async | ready as feature">
  <mat-slide-toggle
    data-at-feature-eco-mode
    gtm="onToggle"
    gtmAction="Eco mode"
    gtmCategory="heatingCircuit"
    #matSlideEcoMode
    *ngIf="feature?.commands?.activate || feature?.commands?.deactivate"
    class="slide-toggle"
    [class.disabled]="comfortFeature$ | async | ready | featureValue: 'active'"
    [checked]="feature?.properties?.active?.value"
    [disabled]="comfortFeature$ | async | ready | featureValue: 'active'"
    (click)="onHeatingProgramChange(feature.feature, feature.properties?.active?.value)"
  >
    {{ '+SCHEDULES.TOGGLE.ECO_MODE' | translate }}
  </mat-slide-toggle>
</ng-container>
<ng-container *ngIf="!(heatingPanelService.isComfortMode$ | async)">
  <mat-slide-toggle
    data-at-feature-comfort-mode
    gtm="onToggle"
    gtmAction="Comfort mode"
    gtmCategory="heatingCircuit"
    #matSlideComfortMode
    *ngIf="comfortFeature$ | async | ready as feature"
    class="slide-toggle"
    [class.disabled]="ecoFeature$ | async | ready | featureValue: 'active'"
    [checked]="feature?.properties?.active?.value"
    [disabled]="
      (operatingModesActive$ | async | value2: featurePropertyKey.value) === 'standby' ||
      (ecoFeature$ | async | ready | featureValue: 'active')
    "
    (click)="onHeatingProgramChange(feature.feature, feature.properties?.active?.value)"
  >
    {{ '+SCHEDULES.TOGGLE.COMFORT_MODE' | translate }}
  </mat-slide-toggle>
</ng-container>
<div *ngIf="heatingPanelService.isComfortMode$ | async">
  {{ '+SCHEDULES.E3_COMFORT_MODE_INFO' | translate }}
</div>
